var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMembershipBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint0_linear_3151_4745)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20.0012C30.5 25.5241 26.0228 30.0012 20.5 30.0012C14.9772 30.0012 10.5 25.5241 10.5 20.0012C10.5 14.4784 14.9772 10.0012 20.5 10.0012C26.0228 10.0012 30.5 14.4784 30.5 20.0012ZM15 20.0012C15 23.0388 17.4624 25.5012 20.5 25.5012C23.5376 25.5012 26 23.0388 26 20.0012C26 16.9637 23.5376 14.5012 20.5 14.5012C17.4624 14.5012 15 16.9637 15 20.0012Z",
    fill: "#D4D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3151_4745",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembershipBlack);
export default __webpack_public_path__ + "static/media/iconMembership_Black.b6fe9907815d4230e38db29381da6846.svg";
export { ForwardRef as ReactComponent };